export const GET_ALL_MINTED_NFT = 'get_all_minted_nft';
export const GET_ALL_MINTED_NFT_SUCCESS = 'get_all_minted_nft_success';
export const GET_ALL_SOLD_NFT = 'get_all_sold_nft';
export const GET_ALL_SOLD_NFT_SUCCESS = 'get_all_sold_nft_success';